/**
 * FeatureLocked — the web locked-with-upgrade card, or the native locked state.
 */

import React from 'react';
import { COMMERCE_ENABLED } from '@/lib/commerce/policy';
import { PlanLockedNotice } from '@/components/commerce/PlanLockedNotice';
import { FEATURE_INFO } from '@/lib/subscription/features';
import { FeatureLockedOffer, type FeatureLockedProps } from './FeatureLockedOffer';

export function FeatureLocked(props: FeatureLockedProps) {
  if (!COMMERCE_ENABLED) {
    const title = props.title ?? FEATURE_INFO[props.feature]?.name ?? 'This feature';
    const variant = props.variant === 'inline' || props.variant === 'minimal' ? 'banner' : 'card';
    return <PlanLockedNotice variant={variant} title={title} />;
  }
  return <FeatureLockedOffer {...props} />;
}
